import { Flex } from '@sendoutcards/quantum-design-ui'
import React from 'react'

type WidgetCardProps = {
  children?: React.ReactNode
  backgroundColor?: string
  borderRadius?: string
  paddingOverride?: string
  shouldHideShadow?: boolean
  boxShadowOverride?: string
  alignment?: 'stretch' | 'start' | 'center'
  minWidth?: string
  height?: string
}

export const WidgetCard: React.FC<WidgetCardProps> = ({
  backgroundColor = '#fff',
  borderRadius = '24px',
  paddingOverride,
  shouldHideShadow,
  boxShadowOverride,
  children,
  alignment = 'center',
  minWidth,
  height,
}) => {
  const fallbackBoxShadow = shouldHideShadow
    ? 'none'
    : '0px 4px 32px rgba(0, 0, 0, 0.04)'
  const resolvedBoxShadow = shouldHideShadow ? 'none' : boxShadowOverride

  return (
    <Flex
      minWidth={minWidth}
      position="relative"
      width="100%"
      justifyContent="center"
      alignItems={
        alignment === 'center'
          ? 'center'
          : alignment === 'stretch'
            ? 'space-between'
            : 'start'
      }
      boxShadow={resolvedBoxShadow}
      style={{
        background: backgroundColor,
        borderRadius: borderRadius,
        padding: paddingOverride ?? '8px 16px 24px 16px',
        height: height,
        boxShadow: boxShadowOverride ? undefined : fallbackBoxShadow,
      }}
    >
      <Flex width="100%" flexDirection="column" style={{ height: '100%' }}>
        {children}
      </Flex>
    </Flex>
  )
}
